import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import {
  getGnomadGenesData,
  getLofZScore,
  getMissenseScore,
} from "../../../../state/selectors/GnomADGene.selectors";
import { getZscoreColor } from "../../../../pages/gene/components/common/helpers";
import NumberToPrecision from "../../../atoms/NumberToPrecision";

const GeneGnomadCard = ({ card, lofZscore, gnomadGenesData, misZScore }) => {
  const isDisabled = !Object.keys(gnomadGenesData || {}).length;
  const lofColor = lofZscore && getZscoreColor(lofZscore);
  const misColor = misZScore && getZscoreColor(misZScore);
  const { version, items } = gnomadGenesData;
  const firstItem = items[0];
  const pli = version === "4.1" ? firstItem?.lof_hc_lc_pli : firstItem?.pli;

  return (
    <CardWrapper {...card} isDisabled={isDisabled} color={lofColor}>
      <div className="tw-flex tw-gap-2">
        <div className="tw-flex tw-flex-col">
          <span>
            pLI: <NumberToPrecision value={100 * pli} suffix="%" />
          </span>
          <span>
            LOEUF: <NumberToPrecision value={firstItem?.oe_lof_upper} />
          </span>
        </div>
        <div className="tw-flex tw-flex-col">
          {lofZscore && (
            <span data-testid="gnomad-genes-mis-z-score">
              Missense:{" "}
              <NumberToPrecision
                className="tw-font-bold"
                style={{ color: misColor }}
                value={misZScore}
              />
            </span>
          )}
          {lofZscore && (
            <span data-testid="gnomad-genes-lof-z-score">
              Loss of Function:{" "}
              <NumberToPrecision
                className="tw-font-bold"
                style={{ color: lofColor }}
                value={lofZscore}
              />
            </span>
          )}
        </div>
      </div>
    </CardWrapper>
  );
};

GeneGnomadCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  gnomadGenesData: PropTypes.shape({
    version: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        pli: PropTypes.number,
        lof_hc_lc_pli: PropTypes.number,
        oe_lof_upper: PropTypes.number,
      })
    ),
  }),
  lofZscore: PropTypes.number,
  misZScore: PropTypes.number,
};

GeneGnomadCard.defaultProps = {
  gnomadGenesData: {
    items: [],
  },
  lofZscore: null,
  misZScore: null,
};

const mapStateToProps = (state) => ({
  gnomadGenesData: getGnomadGenesData(state),
  lofZscore: getLofZScore(state),
  misZScore: getMissenseScore(state),
});

export default connect(mapStateToProps, {})(GeneGnomadCard);
